import { authFetch, BASE_BACKEND_URL, fetchWithAuth } from '../../../auth'

const SPECIAL_PRICES_URL = `${BASE_BACKEND_URL}/special_prices`
const SPECIAL_PRICE_CANDIDATE_PRODUCTS_URL = `${SPECIAL_PRICES_URL}/candidate_products`
const SPECIAL_PRICE_PRICE_LISTS_URL = `${BASE_BACKEND_URL}/price_lists?page=1&per_page=1000`
const SPECIAL_PRICE_PROMO_QUALIFIERS_URL = `${BASE_BACKEND_URL}/promo_qualifiers`

const getSpecialPriceDetailUrl = (id = '') =>
  `${BASE_BACKEND_URL}/special_prices${id ? `/${id}` : ''}`

const parseJsonSafely = async (response) => {
  if (!response) return null

  const rawBody = await response.text()
  if (!rawBody) return null

  try {
    return JSON.parse(rawBody)
  } catch (error) {
    console.error('specialPriceApi parse error:', error)
    return null
  }
}

const requestWithAuth = async (url, options = {}) => {
  const response = await authFetch(url, options)
  if (!response) return null

  const data = await parseJsonSafely(response)

  return {
    ok: response.ok,
    status: response.status,
    data
  }
}

export const fetchSpecialPrices = async (queryString = '') => {
  return fetchWithAuth(`${SPECIAL_PRICES_URL}${queryString ? `?${queryString}` : ''}`, {
    method: 'GET'
  })
}

export const fetchSpecialPriceFilterInfo = async () => {
  return fetchWithAuth(`${SPECIAL_PRICES_URL}?filter_info=true`, {
    method: 'GET'
  })
}

export const fetchSpecialPriceDetail = async (id) => {
  return fetchWithAuth(getSpecialPriceDetailUrl(id), {
    method: 'GET'
  })
}

export const suspendSpecialPrice = async (id) => {
  return requestWithAuth(getSpecialPriceDetailUrl(id), {
    method: 'DELETE'
  })
}

export const createSpecialPrice = async (payload) => {
  return requestWithAuth(SPECIAL_PRICES_URL, {
    method: 'POST',
    body: JSON.stringify(payload)
  })
}

export const fetchSpecialPricePriceLists = async () => {
  return fetchWithAuth(SPECIAL_PRICE_PRICE_LISTS_URL, {
    method: 'GET'
  })
}

export const fetchSpecialPriceQualifiers = async () => {
  return fetchWithAuth(SPECIAL_PRICE_PROMO_QUALIFIERS_URL, {
    method: 'GET'
  })
}

export const fetchSpecialPriceClients = async (query) => {
  return fetchWithAuth(
    `${BASE_BACKEND_URL}/clients?q=${encodeURIComponent(query)}&active=true&page=1&per_page=25`,
    {
      method: 'GET'
    }
  )
}

export const fetchSpecialPriceCandidateProducts = async ({ page = 1, payload }) => {
  return requestWithAuth(`${SPECIAL_PRICE_CANDIDATE_PRODUCTS_URL}?page=${page}&per_page=25`, {
    method: 'POST',
    body: JSON.stringify(payload)
  })
}
